<template>
  <div id="grid-videos">
    <v-container grid-list-xl fluid>
      <div v-if="loading">
        <loading></loading>
      </div>
      <template>
        <v-layout justify-center>
          <v-flex lg12>
            <v-data-table
              :headers="headers"
              :items="itemsVideos"
              :rows-per-page-items="rowsTable"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.filename }}</td>
                <td class="text-xs-left">{{ props.item.descripcion }}</td>
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Descargar Video"
                    @click="downloadFile(props.item.id, props.item.filename)"
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="usuarioLoggedTipe == 'ADMINISTRADOR'"
                    :loading="loading"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="red darken-4"
                    small
                    title="Eliminar video"
                    @click="openDeleteDialog(props.item.id)"
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </template>
      <v-dialog v-model="dialogVideo" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogVideo = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="deleteVideo()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="dialogLoading" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "grid-videos",
  components: {
    LoadingDescarga,
    Loading,
  },
  props: {
    itemsVideos: {},
    rowsTable: "",
    deleteIcon: "",
  },
  data() {
    return {
      dialogLoading: false,
      dialogVideo: false,
      loading: false,
      alerta: false,
      userlogged: "",
      idToDelete: "",
      usuarioLoggedTipe: "",
      btnEdit: false,
      dialogDelete: false,
      headers: [
        { text: "Nombre", align: "left", sortable: false, value: "accion" },
        {
          text: "Descripción",
          align: "left",
          sortable: false,
          value: "usuario",
        },
        {
          text: "Acciones",
          sortable: false,
          value: "",
        },
      ],
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  mounted() {
    //this.loadDataVideo();
    this.userId = this.$store.getters.userLogged.id;
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.userLogged = this.$store.getters.userLogged.id;
  },
  computed: {},
  methods: {
    openDeleteDialog(id) {
      this.idToDelete = id;
      this.dialogVideo = true;
    },
    reloadGrid() {
      setTimeout(() => {
        this.$parent.$parent.reloadVideos();
        // this.$router.go(-1)
      }, 1000);
    },
    async deleteVideo() {
      await this.delete();
      this.reloadGrid();
      this.dialogVideo = false;
    },
    async delete() {
      return await axios
        .delete("/public/deleteArchivo/" + this.idToDelete)
        .then(function (response) {
          response.data;
          //this.reloadGrid();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    downloadFile(id, filename) {
      this.dialogLoading = true;
      axios
        .get("/public/downloadArchivo/" + id, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
